// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @helpers
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const {
    CARDS_CANCEL_PAY_LATER_FAILURE,
    CARDS_CANCEL_PAY_LATER_INPROGRESS,
    CARDS_CANCEL_PAY_LATER_SET_VISIBLE_STEP,
    CARDS_CANCEL_PAY_LATER_SUCCESS,
    CARDS_CANCEL_PAY_LATER_VALIDATE_STEP,
    CARDS_CANCEL_PAY_LATER_WILL_CANCEL,
    RESET_CARDS_CANCEL_PAY_LATER,
} = require('constants/actionTypes');

const validateStep = (step) => ({
    type: CARDS_CANCEL_PAY_LATER_VALIDATE_STEP,
    payload: {
        step
    }
});

const reset = () => (dispatch) => {
    dispatch({
        type: RESET_CARDS_CANCEL_PAY_LATER
    });
};

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: CARDS_CANCEL_PAY_LATER_SET_VISIBLE_STEP,
        payload: { step }
    });
};

const cancelCardPayLaterSuccess = (response) => ({
    type: CARDS_CANCEL_PAY_LATER_SUCCESS,
    payload: {
        response
    }
});

const cancelCardPayLaterError = (error) => ({
    type: CARDS_CANCEL_PAY_LATER_FAILURE,
    payload: {
        error
    }
});

const cancelPayLaterFetching = () => ({
    type: CARDS_CANCEL_PAY_LATER_INPROGRESS
})

const finish = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCardCancelPayLaterInfo = getState().creditCardPayLaterInfo;
        const immCardCancelPayLaterData = immCardCancelPayLaterInfo.getIn(['payLaterData', 'movements', '0']);
        const immCards = getState().cards;
        const immCard = immCards.getIn(['byId',cardId]);
        const params = {
            query: {
                producto: immCard.getIn(['contract', 'product'], ''),
                numerodecontrato: immCard.getIn(['contract', 'number'], ''),
                tiposit: immCardCancelPayLaterData.get('tiposit'),
                dataToken: dataToken,
                numero: immCardCancelPayLaterData.get('numero')
            }
        };
        dispatch(cancelPayLaterFetching());
        return APIPost({
            dispatch,
            endpoint: 'cardCancelPayLater',
            params: params
        })
            .then(response => {
                dispatch(cancelCardPayLaterSuccess(response));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(cancelCardPayLaterError(response.error));
                } else {
                    throw response;
                }
            });
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};


const setWillCancel = (willCancel) => ({
    type: CARDS_CANCEL_PAY_LATER_WILL_CANCEL,
    payload: {
        willCancel
    }
});

module.exports = {
    finish,
    reset,
    setVisibleStep,
    setWillCancel,
    validateStep,
};